import React, { Component } from 'react';
import Slider from 'react-slick';
import { imageBasePath } from '../../constants/staticData';
import Arrow from "./Arrow";

export default class Testimonials extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      currentSlide:1
    }

  }
  componentDidMount() { setTimeout(() => {window.dispatchEvent(new Event('resize')) }, 6000); }





  render() {


    const { promotionalOffersData, router } = this.props;


    const testimonialData = [

      {
        user:"Ginto George",
        text: "Carcility has helped me quickly to find the most appropriate workshop for my car's major service at the best rates which are almost 70% cheaper then the dealers.",
        url: "review-ginto-george.png",
        alt:"Ginto george reviews Carcility"
      },
      {
        user:" Christina John",
        text: "Carcility is a great platform for all car services. I was very happy with the services provided. Very prompt responses and great customer service.",
        icon: "C"
      },
      {
        user:"Anjali",
        text: "Really like their service! I got my car serviced through them and got multiple quotations pretty quick. Thank you Carcility, keep up the good work.",
        url : "review-anjali.png",
        alt:"Anjali reviews carcility"
      },  {
        user:"Nadeen Nasr",
        text: "It's perfect. So I got about 4 or 5 quotes and they came in so quick wow, like you can even chat with the garages if you have quick queries.he process to book a service is so easy.",
        icon: "N"
      },  {
        user:"Michael Moffat",
        text: "In short Carcility saved me AED 5,750 with zero hassle!!!\n" +
          "All in all I was able to secure comparable or better tyres (Michelin, current year), fitting and a new battery from the same supplier as the original manufacturer for a fraction of the cost (AED 2,750) total.\n" +
          "\n" +
          "Carcility service were attentive and available throughout the process.",
        icon: "M"
      },{
        user:"Alan Davis",
        text: "A must have app for all those who own a car in UAE. It is great to have a couple of quotes for the required job from trusted garages across the city.",
        icon: "A"
      },
    ];
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      nextArrow: <Arrow type="next" />,
      prevArrow: <Arrow type="prev" />,
      responsive: [
        {
          breakpoint: 640,
          settings: { slidesToShow: 1, dots: true}
        },
        {
          breakpoint: 840,
          settings: { slidesToShow: 2 }
        },
        {
          breakpoint: 1024,
          settings: { slidesToShow: 3 }
        },
        {
          breakpoint: 1100,
          settings: { slidesToShow: 3 }
        },
        {
          breakpoint: 1400,
          settings: { slidesToShow: 3 }
        },
      ],
      afterChange: (prev, next) => {

        let currentSlide = prev+1;

        if(testimonialData.length == currentSlide){
          currentSlide = 0
        }

        this.setState({ currentSlide: currentSlide });
      },
    };


    /*


        let promoCodesHtml =  promotionalOffersData.map((promoCode, index) => {
          return (
            <div className="col-md-4" key={index}  onClick={(e)=> this.onOfferClick(promoCode.services[0].parentId,index) && e.preventDefault()}  >
              <div className="deal-img">
                <img src={  promoCode.images && promoCode.images[0] ?  promoCode.images[0].medium : `${imageBasePath}/images/default-offer-image.png` } alt="" />
              </div>
            </div>
          );
        });

    */


    let reviewHtml =  testimonialData.map((testimonial, index) => {
      return (
        <div className={this.state.currentSlide == index?"review-active":"" } key={index} >
          <div  className="review-box">
            {testimonial.url ?
              <img src={`${imageBasePath}/images/quick-booking/` + testimonial.url} alt={testimonial.alt?testimonial.alt:""}/>
              :
              <span className="icon-alphabet">{testimonial.icon}</span>
            }


            <h2>{testimonial.user}</h2>
            <ul>
              <li><img src={`${imageBasePath}/images/quick-booking/review-star-active.png`} alt="" /></li>
              <li><img src={`${imageBasePath}/images/quick-booking/review-star-active.png`} alt="" /></li>
              <li><img src={`${imageBasePath}/images/quick-booking/review-star-active.png`} alt="" /></li>
              <li><img src={`${imageBasePath}/images/quick-booking/review-star-active.png`} alt="" /></li>
              <li><img src={`${imageBasePath}/images/quick-booking/review-star-active.png`} alt="" /></li>

            </ul>
            <div className="review-description">{testimonial.text}</div>
          </div>

        </div>
      );
    });



    return (
      <div className="deals-section testimonial-section review-section " id="deals-section">
        <div className="col-md-12 Deals-layout dashboard-row">
          {reviewHtml ?
            <Slider ref="slick" {...settings} >
              {reviewHtml}
            </Slider>
            :""}
        </div>
      </div>
    );
  }
}
